import React from 'react'

const BehaviorTimerContext = React.createContext({
    active: true,
    setActive: (active : boolean) => {}
})

export const BehaviorTimerProvider = BehaviorTimerContext.Provider
export default BehaviorTimerContext